(function () {

    'use strict';

    angular.module('iplusjs.utils.bindHtmlCompile', [])
        .directive('iplusjsBindHtmlCompile', bindHtmlCompile);

    bindHtmlCompile.$inject = [
        '$compile'
    ];
    function bindHtmlCompile($compile) {
        return {
            restrict: 'A',
            link: function ($scope, $element, $attrs) {
                $scope.$watch(function () {
                    return $scope.$eval($attrs.iplusjsBindHtmlCompile);
                }, function (value) {
                    var scope = $scope;

                    if ($attrs.abhcScope) {
                        scope = $scope.$eval($attrs.abhcScope);
                    }

                    $element.html(value && value.toString());
                    $compile($element.contents())(scope);
                });
            }
        };
    }

})();
